// extracted by mini-css-extract-plugin
module.exports = {"renewDialogContent":"styles_renewDialogContent__1Jezt","renewDialogButtons":"styles_renewDialogButtons__1dTpK"};